export const negative = (c) => {
    c.r = 255 - c.r;
    c.g = 255 - c.g;
    c.b = 255 - c.b;
};
